module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-gift-open-34dd249e2a9119602bd4b817c2617465.svg";